import { proxy } from 'valtio'

import { CurrentUserStateType, OddsFormat, TourStages } from '@app/types'
// ONBOARDING DISABLED FOR TIPSTERIZER
import { UserOnboardingStages, UserRoles } from '@app/graphql'
import { initializeUserStateFromCache } from '@app/helpers/initializeUserState'
import { USER_CACHE_KEY } from '@app/constants'

const initialTourStage: TourStages = {
  basicWelcome: false,
  basicVideoExplainer: false,
  contentWelcome: false,
  contentVideoExplainer: false,
  contentTipComparison: false,
  contentTipMenu: false,
  ContentDataTip: false,
  ContentImageTip: false,
  subscriptionMenu: false,
  subscriptionWelcome: false,
  subscriptionVideoExplainer: false,
  subcriptionServiceMenu: false,
  subscriptionFeatureBanner: false,
  userInviteWelcome: false,
  userInviteMenu: false,
  startAppBanner: false,
  userCompletedOnboarding: false,
}

const initialState: CurrentUserStateType = {
  isTipsterAdmin: false,
  hasPendingSubscription: false,
  // ONBOARDING DISABLED FOR TIPSTERIZER
  initiateOnboarding: false,
  userDataLoading: true,
  avatarUrl: '',
  authBySocial: false,
  bio: '',
  birthday: null,
  confirmedConditions: false,
  countryId: '',
  id: null,
  incognitoMode: false,
  name: '',
  phone: '',
  profileBackgroundUrl: '',
  surname: '',
  userEmail: '',
  userType: null,
  username: '',
  gender: null,
  banned: false,
  muted: false,
  notedAboutMute: false,
  permAddPost: false,
  permEditPost: false,
  onboardingStage: null,
  ownedChannels: [],
  followedChannels: [],
  favoriteTenantBookieId: null,
  auth_type: null,
  unitValue: 0,
  unitShare: 0,
  oddsFormat: OddsFormat.Decimal,
  tourStage: initialTourStage,
  isTourCompleted: false,
  currentTourStage: 'basicWelcome',

  get isTouring() {
    return false
    if (guestMode()) return false
    if (this.tourStage.startAppBanner) return false
    if (localStorage.getItem('exitAppTour')) return false
    return !Object.values(this.tourStage).every((stage) => stage)
  },
  get currentChannelId() {
    const stored = localStorage.getItem('currentChannelId')
    if (stored) return stored
    return this.ownedChannels[0]?.id ?? this.followedChannels[0]?.id ?? '-1'
  },
  get guestMode() {
    if (sessionStorage.getItem('incognitoMode')) {
      activateGuestMode()
    }
    return this.incognitoMode
  },
  get isTipster() {
    return this.userType === UserRoles.Tipster
  },
  get isGuestTipster() {
    return this.userType === UserRoles.Tipster && this.incognitoMode
  },
  get isAdmin() {
    return this.userType === UserRoles.Admin
  },
  get isUser() {
    return this.userType === UserRoles.User
  },
  get hasOnboarded() {
    return this.onboardingStage === UserOnboardingStages.Onboarded
  },
}

export const CurrentUserState = proxy<CurrentUserStateType>(initialState)

// Initialize user state from cache immediately on module load
// This ensures the state is populated before any components render
initializeUserStateFromCache(CurrentUserState)

export const resetCurrentUserState = () => {
  Object.keys(initialState).forEach((key) => {
    CurrentUserState[key] = initialState[key]
  })
}

export const activateGuestMode = () => {
  sessionStorage.setItem('incognitoMode', 'true')
  CurrentUserState.confirmedConditions = true
  CurrentUserState.incognitoMode = true
  CurrentUserState.onboardingStage = UserOnboardingStages.Onboarded
}

export const guestMode = () => {
  return (
    sessionStorage.getItem('incognitoMode') === 'true'
  )
}

export const exitGuestMode = () => {
  CurrentUserState.incognitoMode = false
  sessionStorage.removeItem('incognitoMode')
  sessionStorage.removeItem(USER_CACHE_KEY)
}

export const exitAppTour = () => {
  localStorage.setItem('exitAppTour', '1')
  CurrentUserState.currentTourStage = 'startAppBanner'
}

export const resumeAppTour = () => {
  localStorage.removeItem('exitAppTour')
  CurrentUserState.currentTourStage = 'basicWelcome'
}
